import { render, staticRenderFns } from "./addResponsible.vue?vue&type=template&id=ad344944&scoped=true&"
import script from "./addResponsible.vue?vue&type=script&lang=js&"
export * from "./addResponsible.vue?vue&type=script&lang=js&"
import style0 from "./addResponsible.vue?vue&type=style&index=0&id=ad344944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad344944",
  null
  
)

export default component.exports